const approachCards = [
  {
    icon: 'ri-microscope-line',
    title: 'Clinically Grounded',
    body: "Everything Mandie does is rooted in clinical psychology and evidence-based practice. This is not wellness culture. This is real, rigorous, deeply informed healing work.",
  },
  {
    icon: 'ri-body-scan-line',
    title: 'Somatically Led',
    body: "The body holds what the mind cannot articulate. Mandie's work goes into the nervous system, the womb, and the lived physical experience of being a woman.",
  },
  {
    icon: 'ri-sun-line',
    title: 'Spiritually Honest',
    body: "Mandie holds space for the full woman, including faith, intuition, and the deeper knowing. All of it is welcome here.",
  },
];

export default function ApproachSection() {
  return (
    <section className="bg-[#1A1A1A] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4 text-center">
          The approach
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] text-center mb-14 leading-tight">
          Clinical depth. Spiritual truth. Unapologetic warmth.
        </h2>

        {/* Approach Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto">
          {approachCards.map((card) => (
            <div
              key={card.title}
              className="bg-[#FDFAF8]/10 backdrop-blur-sm border border-[#C9A84C]/20 rounded-lg p-6 md:p-10 flex flex-col"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${card.icon} text-3xl text-[#C9A84C]`} />
              </div>
              <h3 className="font-heading text-xl text-[#FDFAF8] mb-4">
                {card.title}
              </h3>
              <p className="font-body text-sm text-[#E8E8E8] leading-relaxed">
                {card.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}